import React, { useState } from 'react';
import SequenceTable from './sequece_table';

const SequenceProfile = (props) => {
  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  };

  return (
    <div style={{ ...styles.container }}>
      <SequenceTable {...props} />
    </div>
  );
};

export default SequenceProfile;
